<template>
  <div>
    <!--For Story layers-->
    <p class="title is-6 has-text-centered">Story Layers <b-button @click="addLayer()" type="is-success" size="is-small" icon-left="plus"></b-button></p>
    <b-collapse
      class="card"
      animation="slide"
      v-for="(layer, index) of stories"
      :key="`LAYER_${index}`"
      :open="isOpen == index"
      @open="isOpen = index">
      <template #trigger="props">
        <div class="card-header" role="button">
          <p class="card-header-title">
            {{ `Story Layer ${index + 1}` }}
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-button type="is-danger" @click="removeLayer(index)">Remove</b-button>
          </div>

          <div class="column is-6">
            <picture-library-select v-model="layer.picture_library._id" @input="setCurrentPictureLibrary(index)"></picture-library-select>             

            <show-image v-if="layer.picture_library.file" :src="storyLayerImage(layer.picture_library)" />
          </div>
          
          <div class="column is-12">
            <b-field label="Content">
              <b-input type="textarea" placeholder="Please add your content here" v-model="layer.text"></b-input>
            </b-field>
          </div>
          
        </div>
      </div>
    </b-collapse>
    <!--For Story layers end--> 
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import ShowImage from '@/components/General/ShowImage'
export default {
  name : 'set-story',
  components : {
    ShowImage
  },
  props : {
    value : {
      type : Array
    }, // Here value = new_question.stories (in parent component)
  }, 
  data(){
    return {
      isLoading : false,
      isOpen : null,
      stories : this.value,
      new_story : {
        text : '',
        picture_library : {
          _id : null
        },
      },
    }
  },
  computed : {
    ...mapGetters(['fetchPictureLibraries', 'getTeacherToken']),
  },
  methods : {
    ...mapActions(['loadPictureLibraries']),
    setCurrentPictureLibrary(index){
      let current_obj = this.fetchPictureLibraries.find(library => library._id == this.stories[index].picture_library._id)
      if(current_obj){
        this.stories[index].picture_library = Object.assign({}, current_obj)
      }
      
    },
    storyLayerImage(obj){
      let url = null
      if(obj && obj._id){
        url = obj.file
      }

      return url
    },
    addLayer(){
      // Add a new story layer
      const new_story = Object.assign({}, this.new_story)
      this.stories.push(new_story)
      // Showing message to user
      this.$buefy.toast.open({
        message: "New Story Layer Added",
        type: "is-success",
      });
    },
    removeLayer(index){
      this.stories.splice(index, 1)

      //Showing message to user
      this.$buefy.toast.open({
        message: "Story Layer Removed",
        type: "is-success",
      });
    },
    emitData(){
      this.$emit('input', this.stories)
    }
  },
  watch : {
    value: function(new_val){
      this.stories = new_val
    },
    stories : {
      handler(){
        this.emitData()
      },
      deep : true
    }
  },
  created(){
    this.loadPictureLibraries({
      token : this.getTeacherToken
    })
  }
}
</script>
